<template>
  <div class="flex-shrink-0 flex border-t border-gray-200 p-4">
    <div class="flex flex-1 items-center">
      <AccountIcon :initials="userInitials" />
    </div>
    <div
      class="flex-grow ml-3 mr-3 truncate  overflow-ellipses overflow-hidden"
    >
      <p class="text-base font-medium text-gray-700 group-hover:text-gray-900">
        {{ userInfo.name }}
      </p>
      <p class="text-sm text-gray-500 group-hover:text-gray-700">
        {{ userInfo.network ? userInfo.network.name : "Network not available" }}
      </p>
    </div>
    <div class="flex-none flex items-center">
      <button class="px-2 focus:outline-none">
        <i class="fad fa-sign-out" v-on:click="performLogout"></i>
      </button>
    </div>
  </div>
</template>
<script>
import AccountIcon from "@/components/AccountIcon";
import { mapActions, mapGetters } from "vuex";
export default {
  components: { AccountIcon },
  computed: {
    ...mapGetters(["userInfo", "userInitials"])
  },
  methods: {
    ...mapActions(["logout"]),
    performLogout() {
      this.logout().then(() => {
        this.$router.replace("/login");
      });
    }
  }
};
</script>
